<template>
  <Fragment>
    <div class="form-group form-row">
      <StepFieldLabel column-classes="col-5">
        Trailer Tire-Related Road Calls<br /><span>per year</span>
      </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-sm-3 col-md-2">
        <Money
          v-model="form.tireRelatedBreakdownsPerYear"
          v-bind="masks.decimal"
          required
          class="form-control form-control-lg"
          type="text"
          @input="onFieldChange($event, roadCalls.tireRelatedBreakdownsPerYear)"
        />
      </StepInputGroup>
      <HelpIcon>
        Based on November 2003 FMCSA study, there are an average of 2.2
        breakdowns per tractor-trailer per year. 55% of these are reported to be
        tire related, and 75% of those occur on trailer tires.
      </HelpIcon>
    </div>

    <div class="form-group form-row">
      <StepFieldLabel column-classes="col-5">
        Tire Replacement Cost<br /><span>USD</span>
      </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-sm-3 col-md-2">
        <Money
          v-model="form.tireReplacementCost"
          v-bind="masks.money"
          required
          class="form-control form-control-lg"
          type="text"
          @input="onFieldChange($event, roadCalls.tireReplacementCost)"
        />
      </StepInputGroup>
      <div class="col-2 input-group"></div>
    </div>

    <div class="form-group form-row">
      <StepFieldLabel column-classes="col-5">
        Road Call Downtime<br /><span>hours</span>
      </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-sm-3 col-md-2">
        <Money
          v-model="form.downtimeRoadCallsHours"
          v-bind="masks.decimal"
          required
          class="form-control form-control-lg"
          type="text"
          @input="onFieldChange($event, roadCalls.downtimeRoadCallsHours)"
        />
      </StepInputGroup>
    </div>

    <div class="form-group form-row">
      <StepFieldLabel column-classes="col-5">
        Downtime Cost per Hour<br /><span>USD</span>
      </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-sm-3 col-md-2">
        <Money
          v-model="form.downtimePerHourCost"
          class="form-control form-control-lg"
          type="text"
          required
          v-bind="masks.money"
          @input="onFieldChange($event, roadCalls.downtimePerHourCost)"
        />
      </StepInputGroup>
      <HelpIcon>
        Average driver wages and benefits, does not include lost profit.
      </HelpIcon>
    </div>

    <div class="form-group form-row">
      <StepFieldLabel column-classes="col-5">
        Cost of Service Call<br /><span>USD</span>
      </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-sm-3 col-md-2">
        <Money
          v-model="form.costOfRoadCalls"
          required
          v-bind="masks.money"
          class="form-control form-control-lg"
          type="text"
          @input="onFieldChange($event, roadCalls.costOfRoadCalls)"
        />
      </StepInputGroup>
      <HelpIcon>
        Service call cost only. Does not include replacement tire, lost cargo or
        down time.
      </HelpIcon>
    </div>
  </Fragment>
</template>

<script>
import { Money } from 'v-money';
import { Fragment } from 'vue-frag';

import HelpIcon from '../step-elements/HelpIcon.vue';
import StepFieldLabel from '../step-elements/StepFieldLabel.vue';
import StepInputGroup from '../step-elements/StepInputGroup.vue';
import { mapState, mutation, masks } from '../store';
import { defaultRoadCalls } from '../store/state';

export default {
  name: 'RoadCalls',

  components: { Money, Fragment, HelpIcon, StepInputGroup, StepFieldLabel },

  data() {
    return {
      /** @type {RoadCalls} */
      form: defaultRoadCalls('Dual'),
      masks,
    };
  },

  computed: {
    ...mapState({
      /** @returns {RoadCalls} */
      roadCalls: (/** @type {ROICalculatorState} */ state) => {
        return state.formValues.roadCalls;
      },
    }),
  },

  watch: {
    roadCalls: {
      handler: function (newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }

        this.form = JSON.parse(JSON.stringify(newVal));
      },
      immediate: true,
    },
  },

  methods: {
    onFieldChange(formValue, stateValue) {
      if (stateValue == formValue) {
        return;
      }

      this.$store.commit(mutation('SET_ROAD_CALLS'), this.form);
    },
  },
};

/**
 * @typedef {import('../store/state').ROICalculatorState} ROICalculatorState
 * @typedef {import('../store/state').RoadCalls} RoadCalls
 */
</script>
